// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { Equipment } from './equipment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class EquipmentImage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  equipmentImageId: number;
  equipmentId: number;
  imageName: string;
  imageUrl: string;
  equipment: Equipment;
}

